export * from './web';
//# sourceMappingURL=index.js.map